import { Pipe, PipeTransform } from '@angular/core';
import { MapLocation } from '../map/models/map-location.model';
import { MapService } from '../map/services/map.service';

@Pipe({
  name: 'straightLineDistance',
  standalone: true,
})
export class StraightLineDistancePipe implements PipeTransform {
  constructor(private readonly mapService: MapService) {}
  /**
   * Calculates the straight-line (as-the-crow-flies) distance between two geographic coordinates
   * using the Haversine formula. This is the shortest distance over the earth's surface.
   * @param coordinate1 First coordinate object with latitude and longitude
   * @param coordinate2 Second coordinate object with latitude and longitude
   * @returns Straight-line distance between the two points in kilometers, or null if coordinates are invalid
   */
  transform(
    coordinate1: Pick<MapLocation, 'latitude' | 'longitude'> | null | undefined,
    coordinate2: Pick<MapLocation, 'latitude' | 'longitude'> | null | undefined,
  ): number | null {
    return this.mapService.calculateStraightLineDistance(coordinate1, coordinate2);
  }
}
